import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getReportDropdowns = createAsyncThunk(
  "reports/getReportDropdowns",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/admin/getReportDropdowns`);
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const ReportsSlice = createSlice({
  name: "reports",
  initialState: {
    reportsDropdownData: {},
    loading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(getReportDropdowns.pending, (state) => {
        state.loading = true
        state.error = null
    })
    builder.addCase(getReportDropdowns.fulfilled, (state, action) => {
        state.loading = false
        state.reportsDropdownData = action.payload
        state.error = null
    })
    builder.addCase(getReportDropdowns.rejected, (state, action) => {
        state.loading = false
        state.reportsDropdownData = {}
        state.error = action.payload
    })
  },
  reducers: {},
});

// eslint-disable-next-line no-empty-pattern
export const {} = ReportsSlice.actions;

export default ReportsSlice.reducer;
